import { TPAComponentsProvider, Text, TextButton, TextTypography, TextButtonPriority } from '@wix/wix-ui-tpa/cssVars';
import React, { useEffect, useState } from 'react';
import styles from './error-fallback.module.scss';
const TextWithChildren = Text;
const ErrorFallback = _ref => {
  let {
    errorMessage,
    errorId
  } = _ref;
  const isSSR = typeof window === 'undefined';
  const [isReady, setIsReady] = useState(isSSR);
  useEffect(() => {
    setIsReady(true);
  }, []);
  if (!isReady) {
    return null;
  }
  return /*#__PURE__*/React.createElement(TPAComponentsProvider, {
    value: {}
  }, /*#__PURE__*/React.createElement("div", {
    "data-hook": "error-fallback-root",
    className: styles.container
  }, /*#__PURE__*/React.createElement(TextWithChildren, {
    className: styles.title,
    typography: TextTypography.smallTitle
  }, "Something went wrong..."), errorMessage ? /*#__PURE__*/React.createElement(TextWithChildren, {
    "data-hook": "error-fallback-error-message",
    typography: TextTypography.runningText
  }, errorMessage) : null, errorId ? /*#__PURE__*/React.createElement(TextWithChildren, {
    "data-hook": "error-fallback-error-id",
    typography: TextTypography.runningText
  }, "Error ID: ", errorId) : null, /*#__PURE__*/React.createElement(TextButton, {
    className: styles.textButton,
    priority: TextButtonPriority.primary,
    onClick: () => window.location.reload()
  }, "Refresh")));
};
export default ErrorFallback;
//# sourceMappingURL=error-fallback.js.map